import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ink-soft">
        <div className="text-ink-muted font-mono text-sm tracking-wider">SE ÎNCARCĂ...</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    // send to their proper portal
    if (user.role === "client") return <Navigate to="/portal" replace />;
    return <Navigate to="/staff" replace />;
  }
  return children;
}
